import { IconLoader2 } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import RenderIf from 'components/RenderIf/RenderIf';
import FileCard from '../FileCard/FileCard';
import { AISuggestedDocument } from '../../types';
import './DocumentLibrarySuggestions.scss';

interface DocumentLibrarySuggestionsProps {
    suggestions: AISuggestedDocument[];
    isLoadingSuggestions: boolean;
    selectedIds: Set<number>;
    onToggle: (doc: AISuggestedDocument, isSelected: boolean) => void;
}

export const DocumentLibrarySuggestions = ({
    suggestions,
    isLoadingSuggestions,
    selectedIds,
    onToggle,
}: DocumentLibrarySuggestionsProps) => (
    <>
        <RenderIf isTrue={isLoadingSuggestions}>
            <div className="d-flex align-items-center justify-content-center p-2">
                <NSIcon icon={IconLoader2} spin className="mr-2" />
                <span className="text-muted">Generating document suggestions...</span>
            </div>
        </RenderIf>
        <RenderIf isTrue={!isLoadingSuggestions && suggestions.length > 0}>
            <div className="DocumentLibrarySuggestions">
                <div className="text-muted font-12 mb-2">
                    Suggested from document library
                </div>
                <div className="DocumentLibrarySuggestions__list d-flex flex-column cursor--pointer">
                    {suggestions.map(doc => (
                        <FileCard
                            key={doc.id}
                            file={{
                                id: doc.id,
                                name: doc.name,
                                createdAt: new Date(doc.createdAt),
                            }}
                            isSelected={selectedIds.has(doc.id)}
                            onClick={isSelected => onToggle(doc, isSelected)}
                        />
                    ))}
                </div>
                <div className="d-flex align-items-center mt-2">
                    <hr className="flex-fill m-0 border-white" style={{ opacity: 0.5 }} />
                    <span className="px-2 font-12">Or upload new</span>
                    <hr className="flex-fill m-0 border-white" style={{ opacity: 0.5 }} />
                </div>
            </div>
        </RenderIf>
    </>
);
